export const myFiles = [
  {
    id: 1,
    name: 'Illustrations',
    type: 'folder',
    itemCount: '20 Items',
    modified: '2 hours ago',
    details: [
      {
        key: 'File type',
        value: 'Folder'
      },
      {
        key: 'File size',
        value: '800 MB'
      },
      {
        key: 'Storage used',
        value: '800 MB'
      },
      {
        key: 'Files',
        value: '20 items'
      },
      {
        key: 'File location',
        value: 'App Documentation'
      },
      {
        key: 'Last opened',
        value: '05 Jul, 2023'
      },
      {
        key: 'Last modified',
        value: '30 Jun, 2023',
        modifiedBy: 'John Doe'
      },
      {
        key: 'Created date',
        value: '12 Feb, 2023'
      }
    ],
    admin: {
      name: 'Kristine Cadena',
      avatar: 'team/2.webp'
    },
    assignees: [
      {
        name: 'Kristine Cadena',
        avatar: 'team/2.webp'
      },
      {
        name: 'Adrian',
        avatar: 'team/4.webp'
      },
      {
        name: 'Charles',
        avatar: 'team/3.webp'
      },
      {
        name: 'Jennifer Schramm',
        avatar: 'team/avatar.webp'
      },
      {
        name: 'Roy Anderson',
        avatar: 'team/r.webp'
      }
    ],
    fileLink: 'http://sample.info/?insect=fireman&porter=attraction# cave',
    activities: [
      {
        time: '4:33pm',
        icon: 'fa-solid fa-share-nodes',
        iconColor: 'success',
        title: `You have shared this file.`,
        tasker: 'John N. Ward',
        assignees: [
          {
            name: 'Michael Jenkins',
            avatar: 'team/9.webp'
          },
          {
            name: 'Ansolo Lazinatov',
            avatar: 'team/25.webp'
          },
          {
            name: 'Jennifer Schramm',
            avatar: 'team/32.webp'
          },
          {
            name: 'Kristine Cadena',
            avatar: 'team/avatar.webp'
          }
        ],
        more: '+1'
      },
      {
        time: '12:30pm',
        icon: 'fa-solid fa-edit',
        iconColor: 'danger',
        title: 'You have edited this file.',
        tasker: 'John N. Ward'
      },
      {
        time: '9:33am',
        icon: 'fa-solid fa-cloud-arrow-up',
        iconColor: 'info',
        title: 'You have uploaded this file.',
        tasker: 'John N. Ward'
      }
    ]
  },
  {
    id: 2,
    name: 'Retro Ring.jpg',
    type: 'image',
    size: '980 KB',
    img: 'img/file-manager/9.png',
    modified: '10 July, 2023',
    details: [
      {
        key: 'File type',
        value: 'Folder'
      },
      {
        key: 'File size',
        value: '520 MB'
      },
      {
        key: 'Storage used',
        value: '520 MB'
      },
      {
        key: 'Files',
        value: '16 items'
      },
      {
        key: 'File location',
        value: 'App Documentation'
      },
      {
        key: 'Last opened',
        value: '05 Jul, 2023'
      },
      {
        key: 'Last modified',
        value: '10 July, 2023',
        modifiedBy: 'John Doe'
      },
      {
        key: 'Created date',
        value: '12 Feb, 2023'
      }
    ],
    admin: {
      name: 'Raymond Mims',
      avatar: 'team/10.webp'
    },
    assignees: [
      {
        name: 'Raymond Mims',
        avatar: 'team/10.webp'
      },
      {
        name: 'Jonathan',
        avatar: 'team/11.webp'
      },
      {
        name: 'Jack',
        avatar: 'team/12.webp'
      },
      {
        name: 'Jessica',
        avatar: 'team/13.webp'
      }
    ],
    fileLink: 'http://sample.info/?insect=fireman&porter=attraction# cave',
    activities: [
      {
        time: '4:33pm',
        icon: 'fa-solid fa-swatchbook',
        iconColor: 'success',
        title: `Designing the dungeon`,
        tasker: 'Igor Borvibson',
        assignees: [
          {
            name: 'Roy Anderson',
            avatar: 'team/11.webp'
          },
          {
            name: 'Ansolo Lazinatov',
            avatar: 'team/35.webp'
          },
          {
            name: 'Jennifer Schramm',
            avatar: 'team/23.webp'
          },
          {
            name: 'Kristine Cadena',
            avatar: 'team/57.webp'
          }
        ],
        more: '+2'
      },
      {
        time: '03:00pm',
        icon: 'fa-solid fa-edit',
        iconColor: 'danger',
        title: 'You have edited this file.',
        tasker: 'John N. Ward'
      },
      {
        time: '9:00am',
        icon: 'fa-solid fa-cloud-arrow-up',
        iconColor: 'info',
        title: 'You have uploaded this file.',
        tasker: 'John N. Ward'
      }
    ]
  },
  {
    id: 3,
    name: 'Brand Identity',
    type: 'folder',
    itemCount: '16 Items',
    modified: '2 hours ago',
    details: [
      {
        key: 'File type',
        value: 'Folder'
      },
      {
        key: 'File size',
        value: '800 MB'
      },
      {
        key: 'Storage used',
        value: '800 MB'
      },
      {
        key: 'Files',
        value: '20 items'
      },
      {
        key: 'File location',
        value: 'App Documentation'
      },
      {
        key: 'Last opened',
        value: '05 Jul, 2023'
      },
      {
        key: 'Last modified',
        value: '30 Jun, 2023',
        modifiedBy: 'John Doe'
      },
      {
        key: 'Created date',
        value: '12 Feb, 2023'
      }
    ],
    admin: {
      name: 'Carl',
      avatar: 'team/7.webp'
    },
    assignees: [
      {
        name: 'Carl',
        avatar: 'team/7.webp'
      },
      {
        name: 'Robert Allan',
        avatar: 'team/21.webp'
      },
      {
        name: 'Charles',
        avatar: 'team/3.webp'
      },
      {
        name: 'Adrian',
        avatar: 'team/4.webp'
      },
      {
        name: 'Sarah Gill',
        avatar: 'team/28.webp'
      }
    ],
    fileLink: 'http://sample.info/?insect=fireman&porter=attraction# cave',
    activities: [
      {
        time: '4:33pm',
        icon: 'fa-solid fa-share-nodes',
        iconColor: 'success',
        title: `You have shared this file.`,
        tasker: 'John N. Ward',
        assignees: [
          {
            name: 'Michael Jenkins',
            avatar: 'team/9.webp'
          },
          {
            name: 'Ansolo Lazinatov',
            avatar: 'team/25.webp'
          },
          {
            name: 'Jennifer Schramm',
            avatar: 'team/32.webp'
          },
          {
            name: 'Kristine Cadena',
            avatar: 'team/avatar.webp'
          }
        ],
        more: '+1'
      },
      {
        time: '12:30pm',
        icon: 'fa-solid fa-edit',
        iconColor: 'danger',
        title: 'You have edited this file.',
        tasker: 'John N. Ward'
      },
      {
        time: '9:33am',
        icon: 'fa-solid fa-cloud-arrow-up',
        iconColor: 'info',
        title: 'You have uploaded this file.',
        tasker: 'John N. Ward'
      }
    ]
  },
  {
    id: 4,
    name: 'World in Motion.mp4',
    type: 'video',
    video: 'video/2.mp4',
    size: '18 MB',
    modified: '15 July, 2023',
    details: [
      {
        key: 'File type',
        value: 'Folder'
      },
      {
        key: 'File size',
        value: '520 MB'
      },
      {
        key: 'Storage used',
        value: '520 MB'
      },
      {
        key: 'Files',
        value: '16 items'
      },
      {
        key: 'File location',
        value: 'App Documentation'
      },
      {
        key: 'Last opened',
        value: '05 Jul, 2023'
      },
      {
        key: 'Last modified',
        value: '10 July, 2023',
        modifiedBy: 'John Doe'
      },
      {
        key: 'Created date',
        value: '12 Feb, 2023'
      }
    ],
    admin: {
      name: 'William Grant',
      avatar: 'team/1.webp'
    },
    assignees: [
      {
        name: 'William Grant',
        avatar: 'team/1.webp'
      },
      {
        name: 'Kristine Cadena',
        avatar: 'team/2.webp'
      },
      {
        name: 'Charles',
        avatar: 'team/3.webp'
      }
    ],
    fileLink: 'http://sample.info/?insect=fireman&porter=attraction# cave',
    activities: [
      {
        time: '4:33pm',
        icon: 'fa-solid fa-swatchbook',
        iconColor: 'success',
        title: `Designing the dungeon`,
        tasker: 'Igor Borvibson',
        assignees: [
          {
            name: 'Roy Anderson',
            avatar: 'team/11.webp'
          },
          {
            name: 'Ansolo Lazinatov',
            avatar: 'team/35.webp'
          },
          {
            name: 'Jennifer Schramm',
            avatar: 'team/23.webp'
          },
          {
            name: 'Kristine Cadena',
            avatar: 'team/57.webp'
          }
        ],
        more: '+2'
      },
      {
        time: '03:00pm',
        icon: 'fa-solid fa-edit',
        iconColor: 'danger',
        title: 'You have edited this file.',
        tasker: 'John N. Ward'
      },
      {
        time: '9:00am',
        icon: 'fa-solid fa-cloud-arrow-up',
        iconColor: 'info',
        title: 'You have uploaded this file.',
        tasker: 'John N. Ward'
      }
    ]
  },
  {
    id: 5,
    name: 'UI Design',
    type: 'folder',
    itemCount: '10 Items',
    modified: '20 September, 2023',
    details: [
      {
        key: 'File type',
        value: 'Folder'
      },
      {
        key: 'File size',
        value: '520 MB'
      },
      {
        key: 'Storage used',
        value: '520 MB'
      },
      {
        key: 'Files',
        value: '16 items'
      },
      {
        key: 'File location',
        value: 'App Documentation'
      },
      {
        key: 'Last opened',
        value: '05 Jul, 2023'
      },
      {
        key: 'Last modified',
        value: '10 July, 2023',
        modifiedBy: 'John Doe'
      },
      {
        key: 'Created date',
        value: '12 Feb, 2023'
      }
    ],
    admin: {
      name: 'Luke Davies',
      avatar: 'team/5.webp'
    },
    assignees: [
      {
        name: 'Luke Davies',
        avatar: 'team/5.webp'
      },
      {
        name: 'Sophie Grant',
        avatar: 'team/6.webp'
      },
      {
        name: 'Jack',
        avatar: 'team/12.webp'
      },
      {
        name: 'William Ellison',
        avatar: 'team/23.webp'
      },
      {
        name: 'Jennifer Schramm',
        avatar: 'team/avatar.webp'
      }
    ],
    fileLink: 'http://sample.info/?insect=fireman&porter=attraction# cave',
    activities: [
      {
        time: '4:33pm',
        icon: 'fa-solid fa-swatchbook',
        iconColor: 'success',
        title: `Designing the dungeon`,
        tasker: 'Igor Borvibson',
        assignees: [
          {
            name: 'Roy Anderson',
            avatar: 'team/11.webp'
          },
          {
            name: 'Ansolo Lazinatov',
            avatar: 'team/35.webp'
          },
          {
            name: 'Jennifer Schramm',
            avatar: 'team/23.webp'
          },
          {
            name: 'Kristine Cadena',
            avatar: 'team/57.webp'
          }
        ],
        more: '+2'
      },
      {
        time: '03:00pm',
        icon: 'fa-solid fa-edit',
        iconColor: 'danger',
        title: 'You have edited this file.',
        tasker: 'John N. Ward'
      },
      {
        time: '9:00am',
        icon: 'fa-solid fa-cloud-arrow-up',
        iconColor: 'info',
        title: 'You have uploaded this file.',
        tasker: 'John N. Ward'
      }
    ]
  },
  {
    id: 6,
    name: 'Classic Clicks.png',
    type: 'image',
    size: '564 KB',
    img: 'img/file-manager/11.png',
    modified: '2 hours ago',
    details: [
      {
        key: 'File type',
        value: 'Folder'
      },
      {
        key: 'File size',
        value: '800 MB'
      },
      {
        key: 'Storage used',
        value: '800 MB'
      },
      {
        key: 'Files',
        value: '20 items'
      },
      {
        key: 'File location',
        value: 'App Documentation'
      },
      {
        key: 'Last opened',
        value: '05 Jul, 2023'
      },
      {
        key: 'Last modified',
        value: '30 Jun, 2023',
        modifiedBy: 'John Doe'
      },
      {
        key: 'Created date',
        value: '12 Feb, 2023'
      }
    ],
    admin: {
      name: 'William Grant',
      avatar: 'team/1.webp'
    },
    assignees: [
      {
        name: 'William Grant',
        avatar: 'team/1.webp'
      },
      {
        name: 'Kristine Cadena',
        avatar: 'team/2.webp'
      },
      {
        name: 'Charles',
        avatar: 'team/3.webp'
      },
      {
        name: 'Jennifer Schramm',
        avatar: 'team/avatar.webp'
      }
    ],
    more: '+2',
    fileLink: 'http://sample.info/?insect=fireman&porter=attraction# cave',
    activities: [
      {
        time: '4:33pm',
        icon: 'fa-solid fa-share-nodes',
        iconColor: 'success',
        title: `You have shared this file.`,
        tasker: 'John N. Ward',
        assignees: [
          {
            name: 'Michael Jenkins',
            avatar: 'team/9.webp'
          },
          {
            name: 'Ansolo Lazinatov',
            avatar: 'team/25.webp'
          },
          {
            name: 'Jennifer Schramm',
            avatar: 'team/32.webp'
          },
          {
            name: 'Kristine Cadena',
            avatar: 'team/avatar.webp'
          }
        ],
        more: '+1'
      },
      {
        time: '12:30pm',
        icon: 'fa-solid fa-edit',
        iconColor: 'danger',
        title: 'You have edited this file.',
        tasker: 'John N. Ward'
      },
      {
        time: '9:33am',
        icon: 'fa-solid fa-cloud-arrow-up',
        iconColor: 'info',
        title: 'You have uploaded this file.',
        tasker: 'John N. Ward'
      }
    ]
  },
  {
    id: 7,
    name: 'Source Code',
    type: 'folder',
    itemCount: '21 Items',
    modified: '21 September, 2023',
    details: [
      {
        key: 'File type',
        value: 'Folder'
      },
      {
        key: 'File size',
        value: '520 MB'
      },
      {
        key: 'Storage used',
        value: '520 MB'
      },
      {
        key: 'Files',
        value: '16 items'
      },
      {
        key: 'File location',
        value: 'App Documentation'
      },
      {
        key: 'Last opened',
        value: '05 Jul, 2023'
      },
      {
        key: 'Last modified',
        value: '10 July, 2023',
        modifiedBy: 'John Doe'
      },
      {
        key: 'Created date',
        value: '12 Feb, 2023'
      }
    ],
    admin: {
      name: 'Robert Allan',
      avatar: 'team/21.webp'
    },
    assignees: [
      {
        name: 'Robert Allan',
        avatar: 'team/21.webp'
      },
      {
        name: 'Molly William',
        avatar: 'team/27.webp'
      },
      {
        name: 'Sarah Gill',
        avatar: 'team/28.webp'
      },
      {
        name: 'Jennifer Schramm',
        avatar: 'team/avatar.webp'
      }
    ],
    fileLink: 'http://sample.info/?insect=fireman&porter=attraction# cave',
    activities: [
      {
        time: '4:33pm',
        icon: 'fa-solid fa-swatchbook',
        iconColor: 'success',
        title: `Designing the dungeon`,
        tasker: 'Igor Borvibson',
        assignees: [
          {
            name: 'Roy Anderson',
            avatar: 'team/11.webp'
          },
          {
            name: 'Ansolo Lazinatov',
            avatar: 'team/35.webp'
          },
          {
            name: 'Jennifer Schramm',
            avatar: 'team/23.webp'
          },
          {
            name: 'Kristine Cadena',
            avatar: 'team/57.webp'
          }
        ],
        more: '+2'
      },
      {
        time: '03:00pm',
        icon: 'fa-solid fa-edit',
        iconColor: 'danger',
        title: 'You have edited this file.',
        tasker: 'John N. Ward'
      },
      {
        time: '9:00am',
        icon: 'fa-solid fa-cloud-arrow-up',
        iconColor: 'info',
        title: 'You have uploaded this file.',
        tasker: 'John N. Ward'
      }
    ]
  },
  {
    id: 8,
    name: 'Code Backup',
    type: 'folder',
    itemCount: '19 Items',
    modified: '21 September, 2023',
    details: [
      {
        key: 'File type',
        value: 'Folder'
      },
      {
        key: 'File size',
        value: '520 MB'
      },
      {
        key: 'Storage used',
        value: '520 MB'
      },
      {
        key: 'Files',
        value: '16 items'
      },
      {
        key: 'File location',
        value: 'App Documentation'
      },
      {
        key: 'Last opened',
        value: '05 Jul, 2023'
      },
      {
        key: 'Last modified',
        value: '10 July, 2023',
        modifiedBy: 'John Doe'
      },
      {
        key: 'Created date',
        value: '12 Feb, 2023'
      }
    ],
    admin: {
      name: 'Rose Berry',
      avatar: 'team/18.webp'
    },
    assignees: [
      {
        name: 'Rose Berry',
        avatar: 'team/18.webp'
      },
      {
        name: 'Tim Anderson',
        avatar: 'team/22.webp'
      },
      {
        name: 'William Ellison',
        avatar: 'team/23.webp'
      },
      {
        name: 'Jean Renoir',
        avatar: 'team/34.webp'
      },
      {
        name: 'Stanly Drinkwater',
        avatar: 'team/35.webp'
      }
    ],
    fileLink: 'http://sample.info/?insect=fireman&porter=attraction# cave',
    activities: [
      {
        time: '4:33pm',
        icon: 'fa-solid fa-swatchbook',
        iconColor: 'success',
        title: `Designing the dungeon`,
        tasker: 'Igor Borvibson',
        assignees: [
          {
            name: 'Roy Anderson',
            avatar: 'team/11.webp'
          },
          {
            name: 'Ansolo Lazinatov',
            avatar: 'team/35.webp'
          },
          {
            name: 'Jennifer Schramm',
            avatar: 'team/23.webp'
          },
          {
            name: 'Kristine Cadena',
            avatar: 'team/57.webp'
          }
        ],
        more: '+2'
      },
      {
        time: '03:00pm',
        icon: 'fa-solid fa-edit',
        iconColor: 'danger',
        title: 'You have edited this file.',
        tasker: 'John N. Ward'
      },
      {
        time: '9:00am',
        icon: 'fa-solid fa-cloud-arrow-up',
        iconColor: 'info',
        title: 'You have uploaded this file.',
        tasker: 'John N. Ward'
      }
    ]
  },
  {
    id: 9,
    name: 'Trip List.xls',
    type: 'xls',
    size: '553 KB',
    modified: '2 hours ago',
    details: [
      {
        key: 'File type',
        value: 'Folder'
      },
      {
        key: 'File size',
        value: '800 MB'
      },
      {
        key: 'Storage used',
        value: '800 MB'
      },
      {
        key: 'Files',
        value: '20 items'
      },
      {
        key: 'File location',
        value: 'App Documentation'
      },
      {
        key: 'Last opened',
        value: '05 Jul, 2023'
      },
      {
        key: 'Last modified',
        value: '30 Jun, 2023',
        modifiedBy: 'John Doe'
      },
      {
        key: 'Created date',
        value: '12 Feb, 2023'
      }
    ],
    admin: {
      name: 'Warren',
      avatar: 'team/24.webp'
    },
    assignees: [
      {
        name: 'Warren',
        avatar: 'team/24.webp'
      },
      {
        name: 'William Ellison',
        avatar: 'team/23.webp'
      },
      {
        name: 'Charles',
        avatar: 'team/3.webp'
      },
      {
        name: 'Jennifer Schramm',
        avatar: 'team/avatar.webp'
      }
    ],
    more: '+3',
    fileLink: 'http://sample.info/?insect=fireman&porter=attraction# cave',
    activities: [
      {
        time: '4:33pm',
        icon: 'fa-solid fa-share-nodes',
        iconColor: 'success',
        title: `You have shared this file.`,
        tasker: 'John N. Ward',
        assignees: [
          {
            name: 'Michael Jenkins',
            avatar: 'team/9.webp'
          },
          {
            name: 'Ansolo Lazinatov',
            avatar: 'team/25.webp'
          },
          {
            name: 'Jennifer Schramm',
            avatar: 'team/32.webp'
          },
          {
            name: 'Kristine Cadena',
            avatar: 'team/avatar.webp'
          }
        ],
        more: '+1'
      },
      {
        time: '12:30pm',
        icon: 'fa-solid fa-edit',
        iconColor: 'danger',
        title: 'You have edited this file.',
        tasker: 'John N. Ward'
      },
      {
        time: '9:33am',
        icon: 'fa-solid fa-cloud-arrow-up',
        iconColor: 'info',
        title: 'You have uploaded this file.',
        tasker: 'John N. Ward'
      }
    ]
  },
  {
    id: 10,
    name: 'Archive.zip',
    type: 'zip',
    size: '12 MB',
    modified: '10 July, 2023',
    details: [
      {
        key: 'File type',
        value: 'Folder'
      },
      {
        key: 'File size',
        value: '520 MB'
      },
      {
        key: 'Storage used',
        value: '520 MB'
      },
      {
        key: 'Files',
        value: '16 items'
      },
      {
        key: 'File location',
        value: 'App Documentation'
      },
      {
        key: 'Last opened',
        value: '05 Jul, 2023'
      },
      {
        key: 'Last modified',
        value: '10 July, 2023',
        modifiedBy: 'John Doe'
      },
      {
        key: 'Created date',
        value: '12 Feb, 2023'
      }
    ],
    admin: {
      name: 'Nicola Allan',
      avatar: 'team/16.webp'
    },
    assignees: [
      {
        name: 'Nicola Allan',
        avatar: 'team/16.webp'
      },
      {
        name: 'Ansolo Lazinatov',
        avatar: 'team/19.webp'
      },
      {
        name: 'Charles',
        avatar: 'team/3.webp'
      },
      {
        name: 'Jennifer Schramm',
        avatar: 'team/avatar.webp'
      }
    ],
    more: '+8',
    fileLink: 'http://sample.info/?insect=fireman&porter=attraction# cave',
    activities: [
      {
        time: '4:33pm',
        icon: 'fa-solid fa-swatchbook',
        iconColor: 'success',
        title: `Designing the dungeon`,
        tasker: 'Igor Borvibson',
        assignees: [
          {
            name: 'Roy Anderson',
            avatar: 'team/11.webp'
          },
          {
            name: 'Ansolo Lazinatov',
            avatar: 'team/35.webp'
          },
          {
            name: 'Jennifer Schramm',
            avatar: 'team/23.webp'
          },
          {
            name: 'Kristine Cadena',
            avatar: 'team/57.webp'
          }
        ],
        more: '+2'
      },
      {
        time: '03:00pm',
        icon: 'fa-solid fa-edit',
        iconColor: 'danger',
        title: 'You have edited this file.',
        tasker: 'John N. Ward'
      },
      {
        time: '9:00am',
        icon: 'fa-solid fa-cloud-arrow-up',
        iconColor: 'info',
        title: 'You have uploaded this file.',
        tasker: 'John N. Ward'
      }
    ]
  },
  {
    id: 11,
    name: 'Worldly Wonders.jpg',
    type: 'image',
    size: '990 KB',
    img: 'img/file-manager/12.png',
    modified: '10 September, 2023',
    details: [
      {
        key: 'File type',
        value: 'Folder'
      },
      {
        key: 'File size',
        value: '520 MB'
      },
      {
        key: 'Storage used',
        value: '520 MB'
      },
      {
        key: 'Files',
        value: '16 items'
      },
      {
        key: 'File location',
        value: 'App Documentation'
      },
      {
        key: 'Last opened',
        value: '05 Jul, 2023'
      },
      {
        key: 'Last modified',
        value: '10 July, 2023',
        modifiedBy: 'John Doe'
      },
      {
        key: 'Created date',
        value: '12 Feb, 2023'
      }
    ],
    admin: {
      name: 'Carry Anna',
      avatar: 'team/1.webp'
    },
    assignees: [
      {
        name: 'William Grant',
        avatar: 'team/1.webp'
      },
      {
        name: 'Kristine Cadena',
        avatar: 'team/2.webp'
      }
    ],
    fileLink: 'http://sample.info/?insect=fireman&porter=attraction# cave',
    activities: [
      {
        time: '4:33pm',
        icon: 'fa-solid fa-swatchbook',
        iconColor: 'success',
        title: `Designing the dungeon`,
        tasker: 'Igor Borvibson',
        assignees: [
          {
            name: 'Roy Anderson',
            avatar: 'team/11.webp'
          },
          {
            name: 'Ansolo Lazinatov',
            avatar: 'team/35.webp'
          },
          {
            name: 'Jennifer Schramm',
            avatar: 'team/23.webp'
          },
          {
            name: 'Kristine Cadena',
            avatar: 'team/57.webp'
          }
        ],
        more: '+2'
      },
      {
        time: '03:00pm',
        icon: 'fa-solid fa-edit',
        iconColor: 'danger',
        title: 'You have edited this file.',
        tasker: 'John N. Ward'
      },
      {
        time: '9:00am',
        icon: 'fa-solid fa-cloud-arrow-up',
        iconColor: 'info',
        title: 'You have uploaded this file.',
        tasker: 'John N. Ward'
      }
    ]
  },
  {
    id: 12,
    name: 'Phoenix Logs.csv',
    type: 'csv',
    size: '546 KB',
    modified: '2 hours ago',
    details: [
      {
        key: 'File type',
        value: 'Folder'
      },
      {
        key: 'File size',
        value: '800 MB'
      },
      {
        key: 'Storage used',
        value: '800 MB'
      },
      {
        key: 'Files',
        value: '20 items'
      },
      {
        key: 'File location',
        value: 'App Documentation'
      },
      {
        key: 'Last opened',
        value: '05 Jul, 2023'
      },
      {
        key: 'Last modified',
        value: '30 Jun, 2023',
        modifiedBy: 'John Doe'
      },
      {
        key: 'Created date',
        value: '12 Feb, 2023'
      }
    ],
    admin: {
      name: 'William Grant',
      avatar: 'team/1.webp'
    },
    assignees: [
      {
        name: 'William Grant',
        avatar: 'team/1.webp'
      },
      {
        name: 'Kristine Cadena',
        avatar: 'team/2.webp'
      },
      {
        name: 'Charles',
        avatar: 'team/3.webp'
      }
    ],
    fileLink: 'http://sample.info/?insect=fireman&porter=attraction# cave',
    activities: [
      {
        time: '4:33pm',
        icon: 'fa-solid fa-share-nodes',
        iconColor: 'success',
        title: `You have shared this file.`,
        tasker: 'John N. Ward',
        assignees: [
          {
            name: 'Michael Jenkins',
            avatar: 'team/9.webp'
          },
          {
            name: 'Ansolo Lazinatov',
            avatar: 'team/25.webp'
          },
          {
            name: 'Jennifer Schramm',
            avatar: 'team/32.webp'
          },
          {
            name: 'Kristine Cadena',
            avatar: 'team/avatar.webp'
          }
        ],
        more: '+1'
      },
      {
        time: '12:30pm',
        icon: 'fa-solid fa-edit',
        iconColor: 'danger',
        title: 'You have edited this file.',
        tasker: 'John N. Ward'
      },
      {
        time: '9:33am',
        icon: 'fa-solid fa-cloud-arrow-up',
        iconColor: 'info',
        title: 'You have uploaded this file.',
        tasker: 'John N. Ward'
      }
    ]
  },
  {
    id: 13,
    name: 'Notes.xlx',
    type: 'xlx',
    size: '698 KB',
    modified: '2 hours ago',
    details: [
      {
        key: 'File type',
        value: 'Folder'
      },
      {
        key: 'File size',
        value: '800 MB'
      },
      {
        key: 'Storage used',
        value: '800 MB'
      },
      {
        key: 'Files',
        value: '20 items'
      },
      {
        key: 'File location',
        value: 'App Documentation'
      },
      {
        key: 'Last opened',
        value: '05 Jul, 2023'
      },
      {
        key: 'Last modified',
        value: '30 Jun, 2023',
        modifiedBy: 'John Doe'
      },
      {
        key: 'Created date',
        value: '12 Feb, 2023'
      }
    ],
    admin: {
      name: 'Kristine Cadena',
      avatar: 'team/70.webp'
    },
    assignees: [
      {
        name: 'Michael Jenkins',
        avatar: 'team/9.webp'
      },
      {
        name: 'Ansolo Lazinatov',
        avatar: 'team/25.webp'
      },
      {
        name: 'Jennifer Schramm',
        avatar: 'team/32.webp'
      },
      {
        name: 'Kristine Cadena',
        avatar: 'team/avatar.webp'
      }
    ],
    fileLink: 'http://sample.info/?insect=fireman&porter=attraction# cave',
    activities: [
      {
        time: '4:33pm',
        icon: 'fa-solid fa-share-nodes',
        iconColor: 'success',
        title: `You have shared this file.`,
        tasker: 'John N. Ward',
        assignees: [
          {
            name: 'Michael Jenkins',
            avatar: 'team/9.webp'
          },
          {
            name: 'Ansolo Lazinatov',
            avatar: 'team/25.webp'
          },
          {
            name: 'Jennifer Schramm',
            avatar: 'team/32.webp'
          },
          {
            name: 'Kristine Cadena',
            avatar: 'team/avatar.webp'
          }
        ],
        more: '+1'
      },
      {
        time: '12:30pm',
        icon: 'fa-solid fa-edit',
        iconColor: 'danger',
        title: 'You have edited this file.',
        tasker: 'John N. Ward'
      },
      {
        time: '9:33am',
        icon: 'fa-solid fa-cloud-arrow-up',
        iconColor: 'info',
        title: 'You have uploaded this file.',
        tasker: 'John N. Ward'
      }
    ]
  },
  {
    id: 14,
    name: 'Moving Escapes.mp4',
    type: 'video',
    size: '12 MB',
    video: 'video/3.mp4',
    modified: '4 hours ago',
    details: [
      {
        key: 'File type',
        value: 'Folder'
      },
      {
        key: 'File size',
        value: '800 MB'
      },
      {
        key: 'Storage used',
        value: '800 MB'
      },
      {
        key: 'Files',
        value: '20 items'
      },
      {
        key: 'File location',
        value: 'App Documentation'
      },
      {
        key: 'Last opened',
        value: '05 Jul, 2023'
      },
      {
        key: 'Last modified',
        value: '30 Jun, 2023',
        modifiedBy: 'John Doe'
      },
      {
        key: 'Created date',
        value: '12 Feb, 2023'
      }
    ],
    admin: {
      name: 'Kristine Cadena',
      avatar: 'team/70.webp'
    },
    assignees: [
      {
        name: 'Michael Jenkins',
        avatar: 'team/9.webp'
      },
      {
        name: 'Ansolo Lazinatov',
        avatar: 'team/25.webp'
      },
      {
        name: 'Jennifer Schramm',
        avatar: 'team/32.webp'
      },
      {
        name: 'Kristine Cadena',
        avatar: 'team/avatar.webp'
      }
    ],
    fileLink: 'http://sample.info/?insect=fireman&porter=attraction# cave',
    activities: [
      {
        time: '4:33pm',
        icon: 'fa-solid fa-share-nodes',
        iconColor: 'success',
        title: `You have shared this file.`,
        tasker: 'John N. Ward',
        assignees: [
          {
            name: 'Michael Jenkins',
            avatar: 'team/9.webp'
          },
          {
            name: 'Ansolo Lazinatov',
            avatar: 'team/25.webp'
          },
          {
            name: 'Jennifer Schramm',
            avatar: 'team/32.webp'
          },
          {
            name: 'Kristine Cadena',
            avatar: 'team/avatar.webp'
          }
        ],
        more: '+1'
      },
      {
        time: '12:30pm',
        icon: 'fa-solid fa-edit',
        iconColor: 'danger',
        title: 'You have edited this file.',
        tasker: 'John N. Ward'
      },
      {
        time: '9:33am',
        icon: 'fa-solid fa-cloud-arrow-up',
        iconColor: 'info',
        title: 'You have uploaded this file.',
        tasker: 'John N. Ward'
      }
    ]
  },
  {
    id: 15,
    name: 'API Documentation.pdf',
    type: 'pdf',
    size: '4 MB',
    modified: '10 July, 2023',
    details: [
      {
        key: 'File type',
        value: 'Folder'
      },
      {
        key: 'File size',
        value: '520 MB'
      },
      {
        key: 'Storage used',
        value: '520 MB'
      },
      {
        key: 'Files',
        value: '16 items'
      },
      {
        key: 'File location',
        value: 'App Documentation'
      },
      {
        key: 'Last opened',
        value: '05 Jul, 2023'
      },
      {
        key: 'Last modified',
        value: '10 July, 2023',
        modifiedBy: 'John Doe'
      },
      {
        key: 'Created date',
        value: '12 Feb, 2023'
      }
    ],
    admin: {
      name: 'Carry Anna',
      avatar: 'team/71.webp'
    },
    assignees: [
      {
        name: 'Michael Jenkins',
        avatar: 'team/10.webp'
      },
      {
        name: 'Ansolo Lazinatov',
        avatar: 'team/26.webp'
      },
      {
        name: 'Jennifer Schramm',
        avatar: 'team/21.webp'
      },
      {
        name: 'Kristine Cadena',
        avatar: 'team/12.webp'
      }
    ],
    fileLink: 'http://sample.info/?insect=fireman&porter=attraction# cave',
    activities: [
      {
        time: '4:33pm',
        icon: 'fa-solid fa-swatchbook',
        iconColor: 'success',
        title: `Designing the dungeon`,
        tasker: 'Igor Borvibson',
        assignees: [
          {
            name: 'Roy Anderson',
            avatar: 'team/11.webp'
          },
          {
            name: 'Ansolo Lazinatov',
            avatar: 'team/35.webp'
          },
          {
            name: 'Jennifer Schramm',
            avatar: 'team/23.webp'
          },
          {
            name: 'Kristine Cadena',
            avatar: 'team/57.webp'
          }
        ],
        more: '+2'
      },
      {
        time: '03:00pm',
        icon: 'fa-solid fa-edit',
        iconColor: 'danger',
        title: 'You have edited this file.',
        tasker: 'John N. Ward'
      },
      {
        time: '9:00am',
        icon: 'fa-solid fa-cloud-arrow-up',
        iconColor: 'info',
        title: 'You have uploaded this file.',
        tasker: 'John N. Ward'
      }
    ]
  },
  {
    id: 16,
    name: 'Vintage Car.jpg',
    type: 'image',
    size: '980 KB',
    img: 'img/file-manager/13.png',
    modified: '15 July, 2023',
    details: [
      {
        key: 'File type',
        value: 'Folder'
      },
      {
        key: 'File size',
        value: '520 MB'
      },
      {
        key: 'Storage used',
        value: '520 MB'
      },
      {
        key: 'Files',
        value: '16 items'
      },
      {
        key: 'File location',
        value: 'App Documentation'
      },
      {
        key: 'Last opened',
        value: '05 Jul, 2023'
      },
      {
        key: 'Last modified',
        value: '10 July, 2023',
        modifiedBy: 'John Doe'
      },
      {
        key: 'Created date',
        value: '12 Feb, 2023'
      }
    ],
    admin: {
      name: 'Carry Anna',
      avatar: 'team/71.webp'
    },
    assignees: [
      {
        name: 'Michael Jenkins',
        avatar: 'team/10.webp'
      },
      {
        name: 'Ansolo Lazinatov',
        avatar: 'team/26.webp'
      },
      {
        name: 'Jennifer Schramm',
        avatar: 'team/21.webp'
      },
      {
        name: 'Kristine Cadena',
        avatar: 'team/12.webp'
      }
    ],
    fileLink: 'http://sample.info/?insect=fireman&porter=attraction# cave',
    activities: [
      {
        time: '4:33pm',
        icon: 'fa-solid fa-swatchbook',
        iconColor: 'success',
        title: `Designing the dungeon`,
        tasker: 'Igor Borvibson',
        assignees: [
          {
            name: 'Roy Anderson',
            avatar: 'team/11.webp'
          },
          {
            name: 'Ansolo Lazinatov',
            avatar: 'team/35.webp'
          },
          {
            name: 'Jennifer Schramm',
            avatar: 'team/23.webp'
          },
          {
            name: 'Kristine Cadena',
            avatar: 'team/57.webp'
          }
        ],
        more: '+2'
      },
      {
        time: '03:00pm',
        icon: 'fa-solid fa-edit',
        iconColor: 'danger',
        title: 'You have edited this file.',
        tasker: 'John N. Ward'
      },
      {
        time: '9:00am',
        icon: 'fa-solid fa-cloud-arrow-up',
        iconColor: 'info',
        title: 'You have uploaded this file.',
        tasker: 'John N. Ward'
      }
    ]
  },
  {
    id: 17,
    name: 'Sleek Rides.png',
    type: 'image',
    size: '980 KB',
    img: 'img/file-manager/15.png',
    modified: '16 July, 2023',
    details: [
      {
        key: 'File type',
        value: 'Folder'
      },
      {
        key: 'File size',
        value: '520 MB'
      },
      {
        key: 'Storage used',
        value: '520 MB'
      },
      {
        key: 'Files',
        value: '16 items'
      },
      {
        key: 'File location',
        value: 'App Documentation'
      },
      {
        key: 'Last opened',
        value: '05 Jul, 2023'
      },
      {
        key: 'Last modified',
        value: '10 July, 2023',
        modifiedBy: 'John Doe'
      },
      {
        key: 'Created date',
        value: '12 Feb, 2023'
      }
    ],
    admin: {
      name: 'Carry Anna',
      avatar: 'team/71.webp'
    },
    assignees: [
      {
        name: 'Michael Jenkins',
        avatar: 'team/10.webp'
      },
      {
        name: 'Ansolo Lazinatov',
        avatar: 'team/26.webp'
      },
      {
        name: 'Jennifer Schramm',
        avatar: 'team/21.webp'
      },
      {
        name: 'Kristine Cadena',
        avatar: 'team/12.webp'
      }
    ],
    fileLink: 'http://sample.info/?insect=fireman&porter=attraction# cave',
    activities: [
      {
        time: '4:33pm',
        icon: 'fa-solid fa-swatchbook',
        iconColor: 'success',
        title: `Designing the dungeon`,
        tasker: 'Igor Borvibson',
        assignees: [
          {
            name: 'Roy Anderson',
            avatar: 'team/11.webp'
          },
          {
            name: 'Ansolo Lazinatov',
            avatar: 'team/35.webp'
          },
          {
            name: 'Jennifer Schramm',
            avatar: 'team/23.webp'
          },
          {
            name: 'Kristine Cadena',
            avatar: 'team/57.webp'
          }
        ],
        more: '+2'
      },
      {
        time: '03:00pm',
        icon: 'fa-solid fa-edit',
        iconColor: 'danger',
        title: 'You have edited this file.',
        tasker: 'John N. Ward'
      }
    ]
  },
  {
    id: 18,
    name: 'Notes.txt',
    type: 'zip',
    size: '29 MB',
    modified: '17 July, 2023',
    details: [
      {
        key: 'File type',
        value: 'Folder'
      },
      {
        key: 'File size',
        value: '520 MB'
      },
      {
        key: 'Storage used',
        value: '520 MB'
      },
      {
        key: 'Files',
        value: '16 items'
      },
      {
        key: 'File location',
        value: 'App Documentation'
      },
      {
        key: 'Last opened',
        value: '05 Jul, 2023'
      },
      {
        key: 'Last modified',
        value: '10 July, 2023',
        modifiedBy: 'John Doe'
      },
      {
        key: 'Created date',
        value: '12 Feb, 2023'
      }
    ],
    admin: {
      name: 'Carry Anna',
      avatar: 'team/71.webp'
    },
    assignees: [
      {
        name: 'Michael Jenkins',
        avatar: 'team/10.webp'
      },
      {
        name: 'Ansolo Lazinatov',
        avatar: 'team/26.webp'
      },
      {
        name: 'Jennifer Schramm',
        avatar: 'team/21.webp'
      },
      {
        name: 'Kristine Cadena',
        avatar: 'team/12.webp'
      }
    ],
    fileLink: 'http://sample.info/?insect=fireman&porter=attraction# cave',
    activities: [
      {
        time: '4:33pm',
        icon: 'fa-solid fa-swatchbook',
        iconColor: 'success',
        title: `Designing the dungeon`,
        tasker: 'Igor Borvibson',
        assignees: [
          {
            name: 'Roy Anderson',
            avatar: 'team/11.webp'
          },
          {
            name: 'Ansolo Lazinatov',
            avatar: 'team/35.webp'
          },
          {
            name: 'Jennifer Schramm',
            avatar: 'team/23.webp'
          },
          {
            name: 'Kristine Cadena',
            avatar: 'team/57.webp'
          }
        ],
        more: '+2'
      },
      {
        time: '03:00pm',
        icon: 'fa-solid fa-edit',
        iconColor: 'danger',
        title: 'You have edited this file.',
        tasker: 'John N. Ward'
      },
      {
        time: '9:00am',
        icon: 'fa-solid fa-cloud-arrow-up',
        iconColor: 'info',
        title: 'You have uploaded this file.',
        tasker: 'John N. Ward'
      }
    ]
  },
  {
    id: 19,
    name: 'Mountain Majesty.jpg',
    type: 'image',
    size: '2 MB',
    img: 'img/file-manager/16.png',
    modified: '17 July, 2023',
    details: [
      {
        key: 'File type',
        value: 'Folder'
      },
      {
        key: 'File size',
        value: '520 MB'
      },
      {
        key: 'Storage used',
        value: '520 MB'
      },
      {
        key: 'Files',
        value: '16 items'
      },
      {
        key: 'File location',
        value: 'App Documentation'
      },
      {
        key: 'Last opened',
        value: '05 Jul, 2023'
      },
      {
        key: 'Last modified',
        value: '10 July, 2023',
        modifiedBy: 'John Doe'
      },
      {
        key: 'Created date',
        value: '12 Feb, 2023'
      }
    ],
    admin: {
      name: 'Carry Anna',
      avatar: 'team/71.webp'
    },
    assignees: [
      {
        name: 'Michael Jenkins',
        avatar: 'team/10.webp'
      },
      {
        name: 'Ansolo Lazinatov',
        avatar: 'team/26.webp'
      },
      {
        name: 'Jennifer Schramm',
        avatar: 'team/21.webp'
      },
      {
        name: 'Kristine Cadena',
        avatar: 'team/12.webp'
      }
    ],
    fileLink: 'http://sample.info/?insect=fireman&porter=attraction# cave',
    activities: [
      {
        time: '4:33pm',
        icon: 'fa-solid fa-swatchbook',
        iconColor: 'success',
        title: `Designing the dungeon`,
        tasker: 'Igor Borvibson',
        assignees: [
          {
            name: 'Roy Anderson',
            avatar: 'team/11.webp'
          },
          {
            name: 'Ansolo Lazinatov',
            avatar: 'team/35.webp'
          },
          {
            name: 'Jennifer Schramm',
            avatar: 'team/23.webp'
          },
          {
            name: 'Kristine Cadena',
            avatar: 'team/57.webp'
          }
        ],
        more: '+2'
      },
      {
        time: '03:00pm',
        icon: 'fa-solid fa-edit',
        iconColor: 'danger',
        title: 'You have edited this file.',
        tasker: 'John N. Ward'
      }
    ]
  },
  {
    id: 20,
    name: 'Job Confirmation.doc',
    type: 'doc',
    size: '129 KB',
    modified: '17 July, 2023',
    details: [
      {
        key: 'File type',
        value: 'Folder'
      },
      {
        key: 'File size',
        value: '520 MB'
      },
      {
        key: 'Storage used',
        value: '520 MB'
      },
      {
        key: 'Files',
        value: '16 items'
      },
      {
        key: 'File location',
        value: 'App Documentation'
      },
      {
        key: 'Last opened',
        value: '05 Jul, 2023'
      },
      {
        key: 'Last modified',
        value: '10 July, 2023',
        modifiedBy: 'John Doe'
      },
      {
        key: 'Created date',
        value: '12 Feb, 2023'
      }
    ],
    admin: {
      name: 'Carry Anna',
      avatar: 'team/71.webp'
    },
    assignees: [
      {
        name: 'Michael Jenkins',
        avatar: 'team/10.webp'
      },
      {
        name: 'Ansolo Lazinatov',
        avatar: 'team/26.webp'
      },
      {
        name: 'Jennifer Schramm',
        avatar: 'team/21.webp'
      },
      {
        name: 'Kristine Cadena',
        avatar: 'team/12.webp'
      }
    ],
    fileLink: 'http://sample.info/?insect=fireman&porter=attraction# cave',
    activities: [
      {
        time: '4:33pm',
        icon: 'fa-solid fa-swatchbook',
        iconColor: 'success',
        title: `Designing the dungeon`,
        tasker: 'Igor Borvibson',
        assignees: [
          {
            name: 'Roy Anderson',
            avatar: 'team/11.webp'
          },
          {
            name: 'Ansolo Lazinatov',
            avatar: 'team/35.webp'
          },
          {
            name: 'Jennifer Schramm',
            avatar: 'team/23.webp'
          },
          {
            name: 'Kristine Cadena',
            avatar: 'team/57.webp'
          }
        ],
        more: '+2'
      },
      {
        time: '03:00pm',
        icon: 'fa-solid fa-edit',
        iconColor: 'danger',
        title: 'You have edited this file.',
        tasker: 'John N. Ward'
      },
      {
        time: '9:00am',
        icon: 'fa-solid fa-cloud-arrow-up',
        iconColor: 'info',
        title: 'You have uploaded this file.',
        tasker: 'John N. Ward'
      }
    ]
  }
];
